@if (onMaintenance) {
  <maintenance-page> </maintenance-page>
} @else {
  @if (isMobile) {
    <app-browser-mobile-popup (onContinue)="onContinue($event)"> </app-browser-mobile-popup>
  } @else {
    @if (isLoading) {
      <div>
        <app-main-loader-lottie> </app-main-loader-lottie>
      </div>
    } @else {
      <div>
        <router-outlet></router-outlet>
      </div>
    }
  }
}
